import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "London 6",
  "description": "",
  "published": "2007-09-27T00:00:00.000Z",
  "redirect_from": ["/blog/london-6/swizec/150"],
  "categories": "travel",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`On Wednesday, that was yesterday I believe, I went to see Macbeth at a theatre. But not just any Macbeth, oh no. The lead role was played by the one and only Patrick Stewart, I mean Jean-Luc Picard. It was quite gorgeously awesome to be honest. Sure it was a bit boring and dragged on like a skinned cat as Shakespeare is wont to do, but all in all it was quite enjoyable - if only for the fact I saw Jean-Luc Picard.`}</p>
    <p>{`The thing I really love about English theatre is the way it's done rather than perhaps the actual plays and performances. There are many theatres here and they each just have one show at a time, very rarely do they have more than that. So because of this when you want to see a play you can do so every evening at a set time and do not have need for an elaborate schedule and be much inclined to missing plays due to not being in London on the right dates.`}</p>
    <p>{`This also makes the tickets cheaper I believe as the theatre can go through more viewers. For example to see cabaret I paid merely 20 quid for front front row. Macbeth was a bit pricier, but not too much. And on top of it all this system also allows for more elaborate scenery as it does not have to be changed every night.`}</p>
    <p>{`I can only wish there were more days left in which to see plays and such.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      